import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="42" height="42" rx="21" stroke-dasharray="2 2"/>
<rect x="3.5" y="3.5" width="36" height="36" rx="18" fill="#267AFF" fill-opacity="0.15"/>
<path d="M20.1923 27.6235C19.8538 27.6235 19.566 27.4775 19.329 27.1855L16.0409 23.1357C15.9478 23.0257 15.8801 22.9178 15.8378 22.812C15.7997 22.7062 15.7807 22.5962 15.7807 22.4819C15.7807 22.228 15.8653 22.0186 16.0346 21.8535C16.2039 21.6885 16.4176 21.606 16.6757 21.606C16.9677 21.606 17.2131 21.7308 17.412 21.9805L20.1669 25.4717L25.5434 16.9531C25.6534 16.7839 25.7677 16.6654 25.8861 16.5977C26.0046 16.5257 26.1527 16.4897 26.3305 16.4897C26.5886 16.4897 26.8002 16.5701 26.9652 16.731C27.1303 16.8918 27.2128 17.097 27.2128 17.3467C27.2128 17.4482 27.1959 17.5498 27.162 17.6514C27.1282 17.7529 27.0753 17.8587 27.0033 17.9688L21.0619 27.1602C20.8588 27.4691 20.5689 27.6235 20.1923 27.6235Z" fill="white" fill-opacity="0.9"/>
</svg>
`;

export const PendingCheckmarkBubble = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
